import { loadModal } from '../../AsyncLoader';
import FormSubmitButton from '../../forms/FormSubmitButton';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import IconSprites from '../../utils/IconSprites';
import SvgIcon from '../../utils/SvgIcon';

function getModalProperties() {
  const key = ComponentKeys.UTILITY_NAVIGATION;

  return {
    title: ContentStorage.get(key, 'ExpiredModalTitle'),
    text: ContentStorage.get(key, 'ExpiredModalText'),
    button: ContentStorage.get(key, 'ExpiredModalButton'),
  };
}

async function open(onAcknowledge: () => void) {
  const Modal = await loadModal();

  const { title, text, button } = getModalProperties();

  const icon = SvgIcon.getHtml(IconSprites.ExclamationCircleFill, 'tn-cart-expired-modal__heading-icon');

  const $btn = Modal.utils.makePrimaryButton(button);

  $btn.on('click', () => {
    FormSubmitButton.applyBusyStyling($btn[0]);

    setTimeout(() => {
      onAcknowledge();
    }, 100);
  });

  Modal.open({
    className: 'tn-cart-expired-modal',
    title: icon + title,
    bodyContents: text,
    footerContents: $btn,
    closeOnEscape: false,
    closeOnBackdrop: false,
    closeButtonInHeader: false,
    describedById: 'tn-cart-expired-modal-content',
  });
}

export default {
  open,
};
